import(/* webpackMode: "eager", webpackExports: ["ReactQueryContext"] */ "/app/apps/egged/components/ReactQueryContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/egged/theme/ThemeProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/.pnpm/@apollo+client-react-streaming@0.12.2_@apollo+client@3.13.8_@types+react@19.1.6_graphql@16.10_t67q55scq5ce57ttqdzxwhxpe4/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.3_next@14.2.30_react@18.2.0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.3_next@14.2.30_react@18.2.0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.3_next@14.2.30_react@18.2.0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.30_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.30_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.30_@babel+core@7.26.0_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Noto_Sans_Hebrew\",\"arguments\":[{\"subsets\":[\"hebrew\",\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"700\"],\"variable\":\"--noto-sans-hebrew\",\"preload\":true}],\"variableName\":\"notoSansHebrew\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/apollo/apollo-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedTypography"] */ "/app/packages/ui/AnimatedTypography.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/BasicBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/common/bit/MediaQueries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomBreadcrumbs"] */ "/app/packages/ui/CustomBreadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/CustomHelperText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/Form/SelectCustom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/layout/Layout.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/theme/theme.ts");
;
import(/* webpackMode: "eager", webpackExports: ["TransitionUp","TransitionUpComponent"] */ "/app/packages/ui/transitions/TransitionUp.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTransitionUpStyles"] */ "/app/packages/ui/transitions/useTransitionUpStyles.ts");
